import { useEffect, useState } from 'react';
import { Grid } from '@mui/material';

import { ProjectsTable } from '../../components/ProjectsTable/ProjectsTable';
import { PageContainer } from '../../components/PageContainer/PageContainer';
import Widget from '../../components/Widget/Widget';
import { widgetData } from './data';
import { useListCases } from '../../hooks/useListCases';
import { useGetUser } from '../../hooks/useGetUser';
import { useListGroups } from '../../hooks/useListGroups';

export function Projects() {
  const {
    listCases,
    refetch: refetchCases,
    data: listCasesData,
    loading: listCasesLoading,
  } = useListCases({ useCache: true });
  const { getUser, data: userData, loading: userLoading } = useGetUser({ useCache: true });
  const {
    listGroups: listAllUsers,
    data: allUsersData,
    loading: allUsersLoading,
  } = useListGroups({ useCache: true });

  //get data from cache
  const { items: caseItems } = listCasesData?.listCases || {};
  const { items: allUsers } = allUsersData?.listGroups?.[0] || {};
  const { getUser: user } = userData || {};

  const isShowTable = caseItems && allUsers && user;
  const isTableLoading = listCasesLoading || allUsersLoading || userLoading;

  useEffect(() => {
    getUser();
    listCases();
    listAllUsers([{ name: 'All Users' }], 100);
  }, []);

  //state
  const [activeFilter, setActiveFilter] = useState<string | undefined>(undefined);

  const handleFilterWidgetClick = (filter: string) => {
    setActiveFilter(prev => (prev === filter ? undefined : filter));
  };

  return (
    <PageContainer
      title={`Pipeline (${caseItems?.length || 0})`}
      description=" Today, here are the top four actions to focus on:"
      testid="projects-page"
    >
      <Grid container spacing={2}>
        {widgetData.map((widget, index) => (
          <Grid key={index} size={3} sx={{ mb: 2 }}>
            <Widget
              title={widget.title}
              icon={widget.icon}
              description={widget.description}
              active={activeFilter === widget.action?.filter}
              onClick={() => {
                handleFilterWidgetClick(widget.action?.filter || '');
              }}
            />
          </Grid>
        ))}
      </Grid>

      <ProjectsTable
        filter={activeFilter || ''}
        data={caseItems || []}
        allUsers={allUsers || []}
        user={user || null}
        loading={isTableLoading}
        refresh={refetchCases}
      />
    </PageContainer>
  );
}

export default Projects;
